//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;
var $ = require("jquery");

//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties))
};

var data = require("./map.geo.json");

function geojsonMarkerOptions(feature) {
  console.log(feature.properties)

  return {
    radius: 5,
    // fillColor: getColor(feature.properties.type),
    fillColor: feature.properties.foot ? "red" : "#f78e1e",
    color: "#ffffff",
    weight: 1,
    opacity: 1,
    fillOpacity: 0.6
  }
};

var geojson = L.geoJson(data, {
    pointToLayer: function (feature, latlng) {
        return L.circleMarker(latlng);
    },
    style: geojsonMarkerOptions,
    onEachFeature: onEachFeature
}).addTo(map);


var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties))
};

 map.scrollWheelZoom.disable();

 map.fitBounds(geojson.getBounds());
